import React from 'react';
import classnames from 'classnames';
import Icon from '../../../../../../../libraries/utils/components/icon';
import DropdownLink from '../../../../../common/dropdown-link';
import { useTracking } from 'react-tracking';
import { IPageInfo, ModeratedBy, Sorting, ViewType } from '../../../state/types';
import { useTenantConfig } from '../../../../../../tenant-config/useTenantConfig';
import { SAFEST_ENABLED } from '../../../../../../tenant-config/tenantConfigConstants';

const SORTING_ITEMS: { value: Sorting; text: string }[] = [
  { value: Sorting.RELEVANCE, text: 'Relevance' },
  { value: Sorting.NEWEST, text: 'Newest' },
  { value: Sorting.OLDEST, text: 'Oldest' },
  { value: Sorting.SAFEST, text: 'Safest' }
];

function getAllSortTypes(viewType: ViewType) {
  return viewType !== ViewType.TEXT
    ? SORTING_ITEMS.filter(({ value }) => value !== Sorting.RELEVANCE)
    : SORTING_ITEMS;
}

interface Props {
  pageInfo: IPageInfo;
  changePageInfo: (props: Partial<IPageInfo>) => void;
}

const SortTooltip: React.FC<Props> = ({ pageInfo, changePageInfo }) => {
  const { sortBy, viewType } = pageInfo;
  const sortingOptions = getAllSortTypes(viewType);

  const [isSafestEnabled] = useTenantConfig(SAFEST_ENABLED);

  const tracking = useTracking();

  const onSortByClick = (value: Sorting) => {
    tracking.trackEvent({ eventName: 'moderation sorting clicked', sort_type: value });

    const moderatedBy = value === Sorting.SAFEST ? { moderatedBy: ModeratedBy.ALL } : {};

    changePageInfo({ sortBy: value, ...moderatedBy });
  };

  const className = classnames('filter-icon', {
    top: sortBy === 'newest',
    bottom: sortBy === 'oldest'
  });

  const sortByItems = sortingOptions
    .filter(({ text }) => isSafestEnabled || text !== 'Safest')
    .map(({ value, text }) => (
      <span
        key={value}
        onClick={() => onSortByClick(value)}
        className={viewType !== 'spot-history' && text === 'Safest' ? 'gray-out' : ''}
      >
        {text}
        {value === sortBy && <Icon className="selected-tag-icon" name="validation-success" />}
      </span>
    ));
  const selectedText = sortingOptions.find(({ value }) => sortBy === value)?.text || 'Newest';

  return (
    <div className="filter-tooltip">
      <DropdownLink className="sort-dropdown" text={selectedText} items={sortByItems}>
        <Icon name="sort" className={className} />
      </DropdownLink>
    </div>
  );
};

export default SortTooltip;
